/**
 * Card Component - UI Layer
 * Container with padding, border, and shadow
 */

import type { ReactNode } from 'react';
import styles from './Card.module.css';

interface CardProps {
  title?: string;
  description?: string;
  titleExtra?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Card({ title, description, titleExtra, children, className = '' }: CardProps) {
  return (
    <div className={`${styles.card} ${className}`}>
      {(title || description) && (
        <div className={styles.header}>
          {title && (
            <div className={styles.titleRow}>
              <h3 className={styles.title}>{title}</h3>
              {titleExtra}
            </div>
          )}
          {description && <p className={styles.description}>{description}</p>}
        </div>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
}
